<template>
  <div class="table-cell-edit-modal">
    <AlternativeSelect
      v-if="type === 'select'"
      v-model="value"
      v-bind="$attrs"
    />

    <ElInput v-else-if="type === 'text'" v-model="value" v-bind="$attrs" />

    <div class="table-cell-edit-modal__footer">
      <ElButton type="text" @click="cancelHandler">{{ $t('CANCEL') }}</ElButton>
      <ElButton type="primary" @click="saveHandler">{{ $t('SAVE') }}</ElButton>
    </div>
  </div>
</template>

<script>
import AlternativeSelect from '@@/common/AlternativeSelect.vue';
export default {
  name: 'TableCellEditModal',
  components: { AlternativeSelect },
  props: {
    title: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'text',
      validator: val => ['text', 'select'].includes(val),
    },
    // eslint-disable-next-line vue/require-prop-types
    initialValue: {
      // can have any type
      default: null,
    },
  },
  data() {
    return {
      value: this.initialValue,
    };
  },
  methods: {
    cancelHandler() {
      this.$emit('close');
    },
    saveHandler() {
      this.$emit('close', this.value);
    },
  },
};
</script>

<style lang="scss">
.table-cell-edit-modal {
  &__footer {
    margin-top: $global-margin * 2;
    text-align: right;

    @include rtl() {
      text-align: left;
    }
  }
}
</style>
